module.exports = __webpack_public_path__ + "media/guest_foam_is_coming.a2b9214b.mp3";